<!--

Copyright Paul B. Lucas (C) 2024   ALL RIGHTS RESERVED.
Licensed to the University of Illinois Urbana Champaign

This component is a subordinate component which renders the Illinois Wordmark
in a header, providing the unit name also.


Revisions:
    12-17-2024      pblucas     initial creation
    01/02/2025      pblucas     Back adapted to make RWA App UIUC Web Style compliant

-->

<template>
    <div class="_uiuc_header">
      <!-- <link rel="stylesheet" href="https://cdn.brand.illinois.edu/illinois.css"> -->
      <hr class="_org_bar" />
      <a class="_img_link" href="https://illinois.edu" target="_blank">
          <img class="_blockI" src="@/assets/Reversed_Orange_Block_I-Blue_Tab_RGB.png">
      </a>
      
      <p class="_p_uiuc">
          <a class="_uiuc_link" href="https://illinois.edu" target="_blank">University of Illinois Urbana-Champaign</a>
      </p>
      <p class="_p_unit_name">
        <a class="_unit_link" :href="unitLink" target="_blank">{{unit}}</a>
      </p>
      <p class="_p_app_title">
        Asset Manager
      </p>    
    </div>
  </template>
  
  <script>
    
      export default {
        name: 'UIUCHeader',
        props: [
            'unit',
            'unitLink'
        ],
        data () {
          return {        
          }
        }
      
      }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    
    ._uiuc_header {
      min-height: 50px;
      font-family:Monserrat, Avenir, Helvetica, Arial, sans-serif;
      margin: 0;
      padding: 0;
    }
    ._p_uiuc {
      font-family:Monserrat, Avenir, Helvetica, Arial, sans-serif;
      font-size: 13pt;
      font-style: normal;
      font-weight: normal;
      margin: 5px 0 0 120px;
      padding: 5px;
    }
    ._p_unit_name {
      font-family:Monserrat, Avenir, Helvetica, Arial, sans-serif; 
      font-size: 13pt;
      font-style: normal;
      font-weight:normal;
      margin: 20px 0 0 60px;
      padding: 5px;
    }
    ._p_app_title {
      font-family:Monserrat, Avenir, Helvetica, Arial, sans-serif;
      font-size: 15pt;
      color: #13294B;
      font-style: normal;
      font-weight: bold;
      margin: 0 0 0 60px;
      padding: 0 5px;
    }
    ._org_bar {
      width: 99%;
      border: 5px solid #FF5F05;
      margin:0;
      padding: 0;
    }
    ._blockI {
      position: absolute;
      width: 50px;
      left: 60px;
      top: 0;

    }
    ._uiuc_link {
      color: #13294B;
      font-weight: bold;
      text-decoration: none;
    }
    ._uiuc_link:hover {
      color: #FF5F05;
      text-decoration: none;
    }
    ._unit_link {
      color: #13294B;
      font-weight: bold;
      text-decoration: none;
      padding: 0;
    }
    ._unit_link:hover {
      color: #FF5F05;
      text-decoration: none;
    }
    ._img_link {
      text-decoration: none;
    }
    
    @media screen and (max-width: 620px) {
        ._p_uiuc  {
            display: none;
        }
        ._p_unit_name {  
            margin: 60px 0 0 60px;
            padding: 5px;
        }
    }
 
  </style>
  

